import { CIMSSwitchProps } from './types'
import { Switch, Tooltip } from 'antd'
import { useDisabledOptions } from '../../hooks/useDisabledOptions'
import { parseDisabled } from '../../utils/parseDisabled'

function CIMSSwitch({ disabled, tooltipPlacement, ...props }: CIMSSwitchProps) {
  const [options, { some }] = useDisabledOptions(disabled)

  return (
    <Tooltip title={parseDisabled(options)} placement={tooltipPlacement}>
      <Switch disabled={some} {...props} />
    </Tooltip>
  )
}

export default CIMSSwitch
